import { questionsPageUrl } from '@ms/yammer-web-support/dist/urls';
import React, { FC } from 'react';
import { Redirect } from 'react-router';

const RedirectToQuestions: FC = () => <Redirect to={questionsPageUrl} />;

export default RedirectToQuestions;
